import React from 'react'
import { Alert } from 'react-bootstrap'
import i18next from 'i18next'
import classnames from 'classnames'

import adminStyles from './styles/admin.scss'
import creditsIcon from '../assets/images/noun_481825_credits.svg'

export default class Credits extends React.Component {
  render() {
    const { credits, handleOrder, product } = this.props
    const productName = product ? product : 'wopi' // wopi360 | wopi

    return (
      <Alert
        className={classnames(adminStyles.creditsWopi, {
          [adminStyles.creditsWopiSuccess]: credits > 0,
          [adminStyles.creditsWopiWarning]: credits <= 0
        })}
        bsStyle={credits > 0 ? 'success' : 'danger'}
      >
        <img src={creditsIcon} />
        <strong>
          {credits} {i18next.t('pcs')}
        </strong>{' '}
        {i18next.t(`${productName}_credits_left`)}
        <span>|</span>
        <a onClick={handleOrder}>{i18next.t(`order_more_${productName}_credits`)}</a>
      </Alert>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Credits.js